
import Vue from 'vue';

export default Vue.extend({
	name: 'DrawerFormSVG',
	props: {
		iconName: {
			type: String,
			default: 'Drawer Form SVG',
		},
		width: {
			type: [Number, String],
			default: 102,
		},
		height: {
			type: [Number, String],
			default: 81,
		},
		viewBox: {
			type: String,
			default: '0 0 102 81',
		},
	},
});
